import { PropsWithChildren, ReactNode } from "react"

type Props = {
  bold: boolean
  tip?: ReactNode
}

export function Label({ bold, tip, children }: PropsWithChildren<Props>) {
  return (
    <div className="flex items-baseline">
      <div className={`text-lg ${bold ? "font-bold" : "text-gray-800"}`}>
        {children}
      </div>
      {tip && (
        <div className="ml-1 inline-block translate-y-[-1px]">
          <small>{tip}</small>
        </div>
      )}
    </div>
  )
}
